import { Helmet } from "react-helmet-async";
import { absoluteUrl } from "../../config/site";

const DEFAULT_DESCRIPTION =
	"Guías de viaje digitales para explorar destinos, preparar tu itinerario y llevar el plan en el móvil. Viajes Molones.";

function buildTitle(title) {
	if (!title) return "Viajes Molones · Guías de viaje";
	return title.includes("Viajes Molones") ? title : `${title} · Viajes Molones`;
}

/**
 * Meta SEO por ruta (SPA).
 *
 * `noIndex`: páginas que no deben posicionarse (pagos, confirmaciones, etc.).
 * Solo título + robots; sin canonical ni Open Graph para no tratarlas como landings.
 */
export default function SeoHead({
	title,
	description = DEFAULT_DESCRIPTION,
	path = "/",
	imagePath,
	noIndex,
	jsonLd,
}) {
	const fullTitle = buildTitle(title);

	if (noIndex) {
		return (
			<Helmet>
				<html lang="es" />
				<title>{fullTitle}</title>
				<meta
					name="robots"
					content="noindex, nofollow, noarchive"
				/>
				{description ? (
					<meta name="description" content={description} />
				) : null}
			</Helmet>
		);
	}

	const canonical = absoluteUrl(path);
	const ogImage = imagePath
		? absoluteUrl(imagePath.startsWith("/") ? imagePath : `/${imagePath}`)
		: absoluteUrl("/logo512.png");

	return (
		<Helmet>
			<html lang="es" />
			<title>{fullTitle}</title>
			<meta name="description" content={description} />
			<link rel="canonical" href={canonical} />
			<meta
				name="robots"
				content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
			/>
			<meta property="og:type" content="website" />
			<meta property="og:site_name" content="Viajes Molones" />
			<meta property="og:locale" content="es_ES" />
			<meta property="og:title" content={fullTitle} />
			<meta property="og:description" content={description} />
			<meta property="og:url" content={canonical} />
			<meta property="og:image" content={ogImage} />
			<meta property="og:image:alt" content={fullTitle} />
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={fullTitle} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:image" content={ogImage} />
			{jsonLd ? (
				<script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
			) : null}
		</Helmet>
	);
}
